export const UserLoginStatus = {
  ACTIVE: 'active',
  BLOCKED: 'blocked',
  INACTIVE: 'inactive',
};
